<template>
  <div id="change-due-date-dialog">
    <ipub-model :title="'Update Revision Due Date'"
                width="470px"
                :isScroll="false"
                :visable="isVisable"
                @confirm="confirm"
                @cancel="cancel">
      <ipub-date-picker class="mar-b-20"
                        placeholder="Revise Due Day"
                        v-model="reviseDueTime" />
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { editor } from '@/api/editor'
import help from '@/utils/help'
export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    inputData: {
      type: Object,
      default () {
        return {}
      }
    },
  },
  data () {
    return {
      reviseDueTime: '',
      autoSend: true,
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
    })
  },
  watch: {
    isVisable (val) {
      if (!val) {
        this.reviseDueTime = ''
        help.closeAutocomplete()
      } else {
        this.reviseDueTime = this.inputData.reviseDueTime
        help.closeAutocomplete()
      }
    }
  },
  methods: {
    onCheckChange (e, id) {
      if (e) {
        return
      }
      this.params.editorId = id
    },
    async confirm () {
      await editor.reviseTime(this.inputData.id, {
        reviseDueTime: this.reviseDueTime,
        sign: this.inputData.sign,
      })
      this.$message.success({ title: 'Success', content: `This Revise Due Day has been saved!` })
      this.$emit('confirm', this.inputData)
    },
    cancel () {
      this.$emit('cancel')
    },
  }
}
</script>

<style lang="scss" scoped>
</style>
